export const moneyFormatter = (amount: number | null) => {
  if (!amount) return '';
  const amountFixed = amount.toFixed(2).replace('.', ',');
  const amountSliced = amountFixed.split(',');
  return `R$ ${amountSliced[0].replace(/\d+?(?=(?:\d{3})+$)/gim, '$&.')},${
    amountSliced[1]
  }`;
};

export const urlFormatter = (path: string) => {
  switch (path) {
    case '/inicio':
      return 'Início >';
    case '/relatorios/modelos':
      return 'Relatórios > Modelos >';
    case '/relatorios/distdefrotas':
      return 'Relatórios > Distribuição da Frota >';
    case '/relatorios/manutencao/entradasaida':
      return 'Relatórios > Manutenção > Entrada e Saída >';
    case '/relatorios/manutencao/avarias':
      return 'Relatórios > Manutenção > Avarias >';
    case '/relatorios/manutencao/servicos':
      return 'Relatórios > Manutenção > Serviços >';
    case '/relatorios/distribuicaodafrota':
      return 'Relatórios > Distribuição da Frota >';
    case '/agendamentos':
      return 'Agendamentos >';
    case '/novo-agendamento/veiculos':
    case '/novo-agendamento/serviços':
    case '/novo-agendamento/agenda':
      return 'Novo Agendamento >';

    default:
      return 'DEV';
  }
};

export const maskPhone = (phone: string) => {
  phone = phone.replace(/\D/g, '');

  phone = phone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');

  return phone;
};
